import { render, staticRenderFns } from "./IndividualForm.vue?vue&type=template&id=58f545c7&scoped=true&"
import script from "./IndividualForm.vue?vue&type=script&lang=js&"
export * from "./IndividualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f545c7",
  null
  
)

export default component.exports